import storage from 'redux-persist/lib/storage';

import CustomizerReducer from './customizer/CustomizerSlice';
import EcommerceReducer from './apps/eCommerce/ECommerceSlice';
import ChatsReducer from './apps/chat/ChatSlice';
import NotesReducer from './apps/notes/NotesSlice';
import EmailReducer from './apps/email/EmailSlice';
import TicketReducer from './apps/tickets/TicketSlice';
import ContactsReducer from './apps/contacts/ContactSlice';
import UserProfileReducer from './apps/userProfile/UserProfileSlice';
import BlogReducer from './apps/blog/BlogSlice';
import ConfigSlice from './apps/config/ConfigSlice';
import ScheduleReducer from './apps/schedule/ScheduleSlice';
import MessagesReducer from './apps/messages/MessagesSlice';

import { setupListeners } from '@reduxjs/toolkit/query';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import { combineReducers } from 'redux';
import {
  useDispatch as useAppDispatch,
  useSelector as useAppSelector,
  TypedUseSelectorHook,
} from 'react-redux';
import { api } from 'src/services';

// .. real reducres
import AuthReducer from './apps/auth/AuthSlice';
import TournamentReducer from './apps/tournament/TournamentSlice';
import WalletSlice from './apps/wallet/WalletSlice';
import GemsSlice from './apps/gems/GemsSlice';
import ReportingSlice from './apps/reporting/ReportingSlice';
import PermissionsSlice from './apps/permissions/PermissionsSlice';

const persistConfig = {
  key: 'root2',
  storage,
  whitelist: [
    'authReducer',
    'configReducer',
    'customizer',
    'tournamentReducer',
    'gemsReducer',
    'permissionsReducer',
  ],
};

const rootReducer = combineReducers({
  customizer: CustomizerReducer,
  ecommerceReducer: EcommerceReducer,
  chatReducer: ChatsReducer,
  emailReducer: EmailReducer,
  notesReducer: NotesReducer,
  contactsReducer: ContactsReducer,
  ticketReducer: TicketReducer,
  userpostsReducer: UserProfileReducer,
  blogReducer: BlogReducer,
  authReducer: AuthReducer,
  api: api.reducer,
  configReducer: ConfigSlice,
  scheduleReducer: ScheduleReducer,
  tournamentReducer: TournamentReducer,
  walletReducer: WalletSlice,
  gemsReducer: GemsSlice,
  reportingReducer: ReportingSlice,
  permissionsReducer: PermissionsSlice,
  messagesReducer: MessagesReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }).concat(api.middleware);

    return middlewares;
  },
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);

export type AppState = ReturnType<typeof rootReducer>;
export type AppDispatch = typeof store.dispatch;
export const { dispatch } = store;
export const useDispatch = () => useAppDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<AppState> = useAppSelector;

export default store;
